export const linkKinds2plus0 = [
  'co_polar',
  'cross_polar',
  'xpic',
  'sd_2plus0',
  'unlicensed_2plus0',
];

export const linkKinds2plus2 = [
  'co_polar_2plus2',
  'cross_polar_2plus2',
  'xpic_2plus2',
  'sd_2plus2',
];

export const linkKinds4plus0 = [
  'cross_polar_4plus0',
  'co_polar_4plus0',
  'xpic_4plus0',
];

export const linkKindsMultiband = [
  'multi_1plus0',
  'multi_co_polar',
  'multi_cross_polar',
  'multi_xpic',
];

// Multiband 2+0 variants: Link B is itself a 2+0, so performance expands into
// Link B Aggregate + Link B1 + Link B2.
export const linkKindsMultiband2plus0 = [
  'multi_co_polar',
  'multi_cross_polar',
  'multi_xpic',
];

// Multiband 2+0 variants where Link B is a cross-polar / XPIC pair, so its two
// carriers (Link B1 / Link B2) can hold independent polarizations. Co-polar
// (ACCP) is excluded because both carriers share a single polarization.
export const linkKindsMultiband2plus0CrossPol = [
  'multi_cross_polar',
  'multi_xpic',
];

export const linkKindsCC = [
  'carrier_1_cc_2',
  'carrier_2_cc_2',
  'carrier_2_cc_3',
];
